import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

var title = '乘风破浪的蜗蜗-《最强蜗牛》';

const router = new Router({
	mode:'history',	
	base:'/new-edition',
	routes: [
	// base:'/dragon-boat',
	// routes: [
	// 	{
	// 		path: '/',
	// 		meta: { title: '乘风破浪的蜗蜗-《最强蜗牛》' },
	// 		name: 'DragonBoat',
	// 		component: () => import('@/wechat/DragonBoat/DragonBoat/index')
	// 	},
	// 	{
	// 		path: '/enter*',
	// 		meta: { title: '乘风破浪的蜗蜗-《最强蜗牛》' },
	// 		name: 'DragonBoat',
	// 		component: () => import('@/wechat/DragonBoat/DragonBoat/index')
	// 	},
	// 	{
	// 		path: '/game/',
	// 		meta: { title: '乘风破浪的蜗蜗-《最强蜗牛》' },
	// 		name: 'index',
	// 		component: () => import('@/wechat/DragonBoat/Game/index')
	// 	},
	// 	{
	// 		path: '/help*',
	// 		meta: { title: '乘风破浪的蜗蜗-《最强蜗牛》' },
	// 		name: 'help',
	// 		component: () => import('@/wechat/DragonBoat/Help/index.vue')
	// 	},

	// 	{ path: '*', meta: { title: '404未找到' }, name: 'index', component: () => import('@/wechat/NotFound/NotFound/index.vue') },



		// -------------------------------------------------------------------------------------
		// 
		// 最强蜗牛-五一节活动
		// {
		// 	path: '/',
		// 	meta: { title: '最强蜗牛五一节活动' },
		// 	name: 'index',
		// 	component: () => import('@/wechat/LaborDay/LaborDay/index'), children: [
		// 		{ path: 'login', meta: { title: '最强蜗牛五一节活动' }, name: 'login', component: () => import('@/components/login') },
		// 		{ path: 'os', meta: { title: '最强蜗牛五一节活动' }, name: 'os', component: () => import('@/components/os') },
		// 	]
		// },
		// {
		// 	path: '/enter',
		// 	meta: { title: '最强蜗牛五一节活动' },
		// 	name: 'index',
		// 	component: () => import('@/wechat/LaborDay/LaborDay/index'), children: [
		// 		{ path: 'login', meta: { title: '最强蜗牛五一节活动' }, name: 'login', component: () => import('@/components/login') },
		// 		{ path: 'os', meta: { title: '最强蜗牛五一节活动' }, name: 'os', component: () => import('@/components/os') },
		// 	]
		// },
		// {
		// 	path: '/game/',
		// 	meta: { title: '最强蜗牛五一节活动' },
		// 	name: 'index',
		// 	component: () => import('@/wechat/LaborDay/Game/index')
		// },
		// {
		// 	path: '/help*',
		// 	meta: { title: '帮助好友' },
		// 	name: 'help',
		// 	component: () => import('@/wechat/LaborDay/Help/index.vue')
		// },
		// 
		// -------------------------------------------------------------------------------------
		// 
		// 最强蜗牛-瓜分66万活动
		{
			path: '/',
			meta: { title: '最强蜗牛-瓜分66万活动' },
			name: 'index',
			component: () => import('@/wechat/NewEdition/NewEdition/index')
		},
		{
			path: '/index*',
			meta: { title: '最强蜗牛-瓜分66万活动' },
			name: 'index',
			component: () => import('@/wechat/NewEdition/NewEdition/index')
		},
		{
			path: '/enter*',
			meta: { title: '最强蜗牛-瓜分66万活动' },
			name: 'index',
			component: () => import('@/wechat/NewEdition/NewEdition/index')
		},
		{
			path: '/game/',
			meta: { title: '最强蜗牛-瓜分66万活动' },
			name: 'index',
			component: () => import('@/wechat/NewEdition/Game/index')
		},
		{
			path: '/help*',
			meta: { title: '帮助好友' },
			name: 'help',
			component: () => import('@/wechat/NewEdition/Help/index.vue')
		},
		{
			path: '/demo*',
			meta: { title: '开发登录模板' },
			name: 'demo',
			component: () => import('@/wechat/Demo/Demo/index')
		},
	],
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js